<asax-header-search-input-info [searchInput]="searchInput">
  <content *ngTemplateOutlet="content"></content>
</asax-header-search-input-info>

<ng-template #content>
  <div class="text-nowrap">
    <label id="{{'header-filter-label-' + searchInput.id}}"
           for="{{'header-filter-' + searchInput.id}}"
           class="form-label mb-0 me-1">
      {{searchInput.label}}
    </label>
    <i *ngIf="searchInput.isDisabled"
       class="fa-light fa-eye-slash me-1"
       placement="right"
       ngbTooltip="Filter is disabled">
    </i>
  </div>
  <div ngbDropdown
       [autoClose]="'outside'"
       display="dynamic"
       placement="bottom-end">
    <div class="input-group input-group-sm has-validation">
      <button ngbDropdownToggle
              id="{{'header-filter-' + searchInput.id}}"
              type="button"
              class="form-control"
              [class.is-valid]="searchInput?.value?.length > 0"
              [class.border-radius-right-0]="searchInput?.value?.length > 0">
        {{valueToDisplay}}
      </button>
      <button *ngIf="searchInput?.value?.length > 0"
              class="btn btn-light border-dark"
              type="button"
              (click)="clearSearchInputValue()">
        <i class="fa-light fa-xmark"></i>
      </button>
    </div>
    <div ngbDropdownMenu
         class="overflow-auto"
         style="max-height: 40vh">
      <form class="px-2 py-0">
        <div class="input-group input-group-sm">
          <input class="form-control"
                 placeholder="Enter keywords"
                 [(ngModel)]="scienceKeywordsFilterValue"
                 [ngModelOptions]="{standalone: true}">
          <button *ngIf="scienceKeywordsFilterValue?.length > 0"
                  class="btn btn-light border-dark"
                  type="button"
                  (click)="clearScienceKeywordsFilterValue()">
            <i class="fa-light fa-xmark"></i>
          </button>
        </div>
      </form>
      <ng-container *ngFor="let dropdownItemScienceKeyword of dropdownItemScienceKeywords">
        <ng-container *ngIf="shouldScienceCategoryBeDisplayed(dropdownItemScienceKeyword)">
          <div class="dropdown-divider"></div>
          <div class="dropdown-header px-0">
            <button ngbDropdownItem (click)="onScienceCategoryClick(dropdownItemScienceKeyword)">
              <h6>{{dropdownItemScienceKeyword?.category?.name}}</h6>
            </button>
          </div>
          <ng-container *ngFor="let scienceKeyword of dropdownItemScienceKeyword.scienceKeywords">
            <ng-container *ngIf="shouldScienceKeywordBeDisplayed(scienceKeyword)">
              <button ngbDropdownItem
                      (click)="onScienceKeywordClick(scienceKeyword)"
                      [class.active]="scienceKeyword.selected">
                <span [innerHTML]="scienceKeyword.text"></span>
              </button>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>



